import { useMemo } from 'react';
import { mapAssignmentFormInfo } from './mapper';
import { useGroupInfo } from '../useGroupInfo';
import { useDictionaries } from '../useDictionaries';
var useAssignmentFormInfo = function (groupId) {
    var _a = useDictionaries(), dictionaries = _a.response, isDictionariesLoading = _a.isLoading;
    var _b = useGroupInfo(groupId), groupInfo = _b.response, isGroupInfoLoading = _b.isLoading;
    var data = useMemo(function () {
        if (!dictionaries || !groupInfo)
            return null;
        return mapAssignmentFormInfo(dictionaries, groupInfo);
    }, [groupInfo, dictionaries]);
    return {
        response: data,
        isLoading: isDictionariesLoading || isGroupInfoLoading,
    };
};
export { useAssignmentFormInfo };
